import {call, put, takeLatest} from 'redux-saga/effects';
import newsActions from '../actions/news.actions';
import NewsApi from '../api/NewsApi';
import errorActions from '../actions/error.actions';

function* getNews(action) {
    try {
        const data = yield call(NewsApi.getNews, action.payload);
        yield put(newsActions.getNewsSuccess(data));
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(newsActions.getNewsFailed(e));
    }
}

function* getArticle(action) {
    try {
        const data = yield call(NewsApi.getArticle, action.payload);
        yield put(newsActions.getArticleSuccess(data));
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(newsActions.getArticleFailed(e));
    }
}

function* newsSaga() {
    yield takeLatest(newsActions.TYPES.GET_NEWS, getNews);
    yield takeLatest(newsActions.TYPES.GET_ARTICLE, getArticle);
}

export default newsSaga;
